import React from 'react';
import { getStatusDensity2 } from "../../pages/PlanOperationPage/util/function_operation/constants";
import { Symbol } from "../../util/varibles/template";
import Icon, { ICON_NAME } from "../Icon";
import styles from "./style.module.scss";

interface IProps {
    density: number
    max_density?: number
}

const Density: React.FC<IProps> = React.memo(({ density, max_density = 0 }) => {
    const { color = '', colorText } = getStatusDensity2(max_density, density);
    const max = Math.round(max_density * 100000) / 100;

    if (!density)
        return null

    return <div className={`${styles.density} text-[14px]`}>
        <Icon icon={ICON_NAME.TANK_2} style={{ background: color, marginBottom: '-1px' }} />
        <div className="whitespace-nowrap">
            <span className="whitespace-nowrap" style={{ color: colorText }}>{Math.round(density * 100000) / 100} kg/{Symbol.m3} </span>
            {max > 0 && <span className='text-comment ml-[3px] whitespace-nowrap'>({max}kg/{Symbol.m3})</span>}
        </div>
    </div>;
}, (prev, next) =>
    prev.density === next.density
    && prev.max_density === next.max_density);

export default Density;
